export const getAccountDisplayName = (
	account?: { accountNumber: string; accountName: string } | undefined,
) => {
	return account ? `${account.accountNumber} - ${account.accountName}` : "";
};
